import MockAdapter from 'axios-mock-adapter/types'

export function mockChains(mocker: MockAdapter) {
  mocker.onGet('/market/l2/chains').reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          chains: [
            {
              chainId: 13,
              chainType: 0,
              layerOneChainId: '0x34816d',
              mainContract: '0xb88a3c00f5b30c0627834105c54884f415ce8eb3',
              gasTokenId: 36,
              depositConfirmation: 6,
              isSupport: true,
            },
            {
              chainId: 16,
              chainType: 1,
              layerOneChainId: '0x534e5f474f45524c49',
              mainContract:
                '0x018d0c10a88e9baed651edff43b220a8f494a948ca8190970e1b258fc3685e8e',
              gasTokenId: 36,
              depositConfirmation: 1,
              isSupport: false,
            },
            {
              chainId: 17,
              chainType: 0,
              layerOneChainId: '0xc3',
              mainContract: '0x424dce0a3a664f848de9dea25b8b8b02251389ff',
              gasTokenId: 37,
              depositConfirmation: 1,
              isSupport: true,
            },
            {
              chainId: 18,
              chainType: 0,
              layerOneChainId: '0x763',
              mainContract: '0xd803d10056d6c411bcb09f0b80aa242e0e19bdb8',
              gasTokenId: 36,
              depositConfirmation: 1,
              isSupport: true,
            },
            {
              chainId: 6,
              chainType: 0,
              layerOneChainId: '0x8274f',
              mainContract: '0x81720a9733a05f42ebf0c1e18c99c7ba193a9083',
              gasTokenId: 36,
              depositConfirmation: 30,
              isSupport: true,
            },
            {
              chainId: 7,
              chainType: 0,
              layerOneChainId: '0xe704',
              mainContract: '0xd554d99d84e7f7c14e4607599abd9dd289dfcdc6',
              gasTokenId: 36,
              depositConfirmation: 30,
              isSupport: true,
            },
            {
              chainId: 8,
              chainType: 0,
              layerOneChainId: '0x5a2',
              mainContract: '0xeb567f9cfc4015434fe752856e6c5331532e4603',
              gasTokenId: 36,
              depositConfirmation: 30,
              isSupport: true,
            },
          ],
          changePubkeyChainId: 7,
          ethProperty: {
            chainId: 4,
            layerOneChainId: '0x5',
            gateways: [
              {
                chainId: 5,
                l1GatewayContract: '0x5fba7b53698115bcebb29819c7a097505417cad8',
                l2GatewayContract: '0x3a15cfced0d0745b39ea95df7314cc9427094f78',
                tokens: [
                  {
                    tokenId: 17,
                    tokenAddress: '0xc58e02c69bef974d9192e48829a68ba84a52a204',
                    decimal: 6,
                    fastWithdraw: true,
                  },
                  {
                    tokenId: 36,
                    tokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                    decimal: 18,
                    fastWithdraw: false,
                  },
                  {
                    tokenId: 140,
                    tokenAddress: '0x3f0426689093c8f8d45a3376ff97cc06876774b9',
                    decimal: 6,
                    fastWithdraw: true,
                  },
                  {
                    tokenId: 142,
                    tokenAddress: '0xe91dfb39dd76c5ce2b9eadecd23d088433073811',
                    decimal: 18,
                    fastWithdraw: true,
                  },
                ],
              },
              {
                chainId: 7,
                l1GatewayContract: '0xce9df3d07d09ca27afd79a51c8944582dec7623c',
                l2GatewayContract: '0x7bed56659d613020d2d9c9f1351ae6a98ab9e425',
                tokens: [
                  {
                    tokenId: 17,
                    tokenAddress: '0x3119fd5290e3b946a0398dc6571de0ff378da5fd',
                    decimal: 6,
                    fastWithdraw: true,
                  },
                  {
                    tokenId: 36,
                    tokenAddress: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
                    decimal: 18,
                    fastWithdraw: false,
                  },
                  {
                    tokenId: 140,
                    tokenAddress: '0x36504cf172bfd4e84e52f2a857467a84f89b8475',
                    decimal: 6,
                    fastWithdraw: true,
                  },
                  {
                    tokenId: 142,
                    tokenAddress: '0x457e705c8552f79ae70bec19df5cd46f05384fca',
                    decimal: 18,
                    fastWithdraw: true,
                  },
                  {
                    tokenId: 148,
                    tokenAddress: '0xb4257f31750961c8e536f5cfcbb3079437700416',
                    decimal: 6,
                    fastWithdraw: true,
                  },
                ],
              },
            ],
            gasTokenId: 36,
            depositConfirmation: 30,
          },
        },
      },
    ]
  })
}
